import React from 'react';
import { Download } from 'lucide-react';

function StatCard({ label, value, color, pulse, action }) {
  const colors = {
    gray: 'from-gray-600/10 to-gray-800/10 border-gray-500/30',
    yellow: 'from-yellow-600/10 to-yellow-800/10 border-yellow-500/30',
    blue: 'from-blue-600/10 to-blue-800/10 border-blue-500/30',
    green: 'from-green-600/10 to-green-800/10 border-green-500/30',
    red: 'from-red-600/10 to-red-800/10 border-red-500/30'
  };
  const textColors = {
    gray: 'text-gray-400', yellow: 'text-yellow-400', blue: 'text-blue-400',
    green: 'text-green-400', red: 'text-red-400'
  };
  return (
    <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-4`}>
      <div className={`${textColors[color]} text-xs font-bold mb-1`}>{label}</div>
      <div className={`text-xl font-bold text-white flex items-center gap-2 ${pulse ? 'animate-pulse' : ''}`}>
        {value}
        {action}
      </div>
    </div>
  );
}

export default function StatsCards({ stats, formatNumber, onExportHits, exporting }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <StatCard label="TOTAL" value={formatNumber(stats.total)} color="gray" />
      <StatCard label="PENDING" value={formatNumber(stats.pending)} color="yellow" />
      <StatCard label="PROCESSING" value={stats.processing} color="blue" pulse />
      <StatCard
        label="SUCCESS"
        value={formatNumber(stats.success)}
        color="green"
        action={stats.success > 0 && (
          <button onClick={onExportHits} disabled={exporting} className="text-green-400 hover:text-green-300">
            <Download className="w-4 h-4" />
          </button>
        )}
      />
      <StatCard label="FAILED" value={formatNumber(stats.failed)} color="red" />
    </div>
  );
}
